<template>
    <el-row>
        <table-template :queryParams="queryParams" actionUrl="/lcwpbusiness/findApplyWithdrawRecord.action"
                        ref="withdrawRecord">

            <template slot="search">
                <el-date-picker
                        @change="onCreateTimeChanged"
                        clearable
                        end-placeholder="创建截止"
                        range-separator="-"
                        start-placeholder="创建开始"
                        style="width:350px"
                        type="datetimerange"
                        v-model="createTimeSearch">
                </el-date-picker>

                <el-input placeholder="商家名称/手机号" style="margin-left: 10px;width: 200px;"
                          v-model="queryParams.keyword"></el-input>
                <el-button @click="$refs['withdrawRecord'].search()" style="margin-left: 10px;" type="primary">搜索
                </el-button>
                <el-button @click="exportApplyWithdrawRecord()" style="margin-left: 10px" type="danger">导出</el-button>
            </template>

            <template slot="item">
                <el-table-column
                        label="单号"
                        prop="withdrawNumber">
                </el-table-column>
                <el-table-column
                        label="姓名"
                        prop="contacts">
                </el-table-column>
                <el-table-column
                        label="账号"
                        prop="phone">
                </el-table-column>
                <el-table-column
                        label="商家名称"
                        prop="businessName">
                </el-table-column>
                <el-table-column
                        label="提现方式">
                    <template scope="scope">

                      {{scope.row.withdrawType| payTypeFilter}}
                    </template>
                </el-table-column>
                <el-table-column
                        label="提现账户">
                    <template scope="scope">

                     <span v-if="scope.row.withdrawType === 2">
                        {{scope.row.personName}} - {{scope.row.openId}}
                    </span>
                      <span v-else-if="scope.row.withdrawType === 3">
                        {{scope.row.personName}} - {{scope.row.alipayPhone}}
                    </span>
                      <span v-else-if="scope.row.withdrawType === 4">
                        {{scope.row.personName}} - {{scope.row.bankNo}}
                    </span>

                    </template>
                </el-table-column>
                <el-table-column
                        label="金额(元)"
                        prop="money">
                </el-table-column>
                <el-table-column
                        label="审核状态"
                        prop="status">
                    <template scope="scope">
                        {{scope.row.status| authStatusFilter}}
                    </template>
                </el-table-column>
                <el-table-column
                        label="支付状态"
                        prop="payStatus">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status!==3">
                          {{scope.row.payStatus| payStatusFilter}}
                       </span>
                        <span style="color: red;" v-else>无需打款</span>
                    </template>
                </el-table-column>
                <el-table-column
                        label="创建时间"
                        prop="createTime">
                    <template scope="scope">
                        {{scope.row.createTime | dateTimeFormat}}
                    </template>
                </el-table-column>
                <el-table-column
                        label="操作">
                    <template scope="scope">
                        <el-button :confirm-data="{id:scope.row.id,status:2}"
                                   @onConfirm="$refs['withdrawRecord'].loadList()"
                                   confirm-text="请确认你的审核操作是否无误？"
                                   confirm-title="提现审核后不能逆转，请二次确认！"
                                   requestUrl="lcwpbusiness/handleWithdraw.action"
                                   style="color:#0084f5"
                                   type="text"
                                   v-confirm
                                   v-if="scope.row.status===1">通过
                        </el-button>
                        <el-button :confirm-data="{id:scope.row.id,status:3}"
                                   @onConfirm="$refs['withdrawRecord'].loadList()"
                                   confirm-text="请确认你的审核操作是否无误？"
                                   confirm-title="提现审核后不能逆转，请二次确认！"
                                   requestUrl="lcwpbusiness/handleWithdraw.action"
                                   style="color:#0084F5"
                                   type="text"
                                   v-confirm
                                   v-if="scope.row.status===1">拒绝
                        </el-button>
                    </template>
                </el-table-column>
            </template>
        </table-template>
    </el-row>
</template>

<script>
import TableTemplate from '@/components/TableTemplate'
import BasicPager from '@/mixins/BasicPager'
import Config from '@/framework/configs/Config'

export default {
  components: {
    TableTemplate
  },
  name: 'withdrawRecordList',
  extends: BasicPager,
  data: function () {
    return {
      createTimeSearch: null,
      queryParams: {}
    }
  },
  filters: {
    payStatusFilter (value) {
      // '支付状态:1-提现成功；2-提现失败;3-提现正在处理',
      let filterValue = '状态不明确'
      switch (value) {
        case 1:
          filterValue = '提现成功'
          break
        case 2:
          filterValue = '提现失败'
          break
        case 3:
          filterValue = '提现正在处理'
          break
      }
      return filterValue
    },
    authStatusFilter (value) {
      // 状态:1-待审核2-审核通过 3-审核不通过
      let filterValue = '状态不明确'
      switch (value) {
        case 1:
          filterValue = '待审核'
          break
        case 2:
          filterValue = '审核通过'
          break
        case 3:
          filterValue = '审核不通过'
          break
      }
      return filterValue
    },
    payTypeFilter (value) {
      let filterValue = '状态不明确'
      switch (value) {
        case 2:
          filterValue = '微信到零钱'
          break
        case 3:
          filterValue = '支付宝'
          break
        case 4:
          filterValue = '微信到银行'
          break
      }
      return filterValue
    }
  },
  created: function () {
    let loginInfo = this.getLoginInfo()
    if (loginInfo.loginPath === 'channel') {
      this.queryParams.channelId = loginInfo.id
    }
  },
  methods: {
    onCreateTimeChanged (datetime) {
      if (!datetime || datetime[0] == null) {
        this.queryParams.createTimeSearchStart = null
        this.queryParams.createTimeSearchEnd = null
        this.$refs['withdrawRecord'].search()
        return
      }
      this.queryParams.createTimeSearchStart = datetime[0].getTime()
      this.queryParams.createTimeSearchEnd = datetime[1].getTime()
      this.$refs['withdrawRecord'].search()
    },
    exportApplyWithdrawRecord: function () {
      let _this = this

      let userInfo = _this.getLoginInfo()
      let loginPath = userInfo.loginPath
      let id = null
      if (userInfo.id) {
        id = userInfo.id
      } else if (userInfo.employeeId) {
        id = userInfo.employeeId
      }

      let dataStr = '&channelId=' + id

      if (this.queryParams.createTimeSearchStart) {
        dataStr += '&createTimeSearchStart=' + this.queryParams.createTimeSearchStart
      }

      if (this.queryParams.createTimeSearchEnd) {
        dataStr += '&createTimeSearchEnd=' + this.queryParams.createTimeSearchEnd
      }

      if (this.queryParams.keyword) {
        dataStr += '&keyword=' + this.queryParams.keyword
      }

      window.location.href = Config.baseUrl + '/lcwpbusiness/exportApplyWithdrawRecord.action?token=' + userInfo.token + '&loginAccountId=' + id + '&loginPath=' + loginPath + dataStr
    }
  }
}
</script>

<style scoped>

</style>
